import { render, staticRenderFns } from "./MsKhachDuLichList.vue?vue&type=template&id=5ef73bb2&"
import script from "./MsKhachDuLichList.vue?vue&type=script&lang=js&"
export * from "./MsKhachDuLichList.vue?vue&type=script&lang=js&"
import style0 from "./MsKhachDuLichList.vue?vue&type=style&index=0&id=5ef73bb2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports